import { render, staticRenderFns } from "./CollapseItem.vue?vue&type=template&id=5005e041&scoped=true&"
import script from "./CollapseItem.vue?vue&type=script&lang=js&"
export * from "./CollapseItem.vue?vue&type=script&lang=js&"
import style0 from "./CollapseItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CollapseItem.vue?vue&type=style&index=1&id=5005e041&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5005e041",
  null
  
)

export default component.exports